import React from "react";
import { Box, Typography, Grid, Button, IconButton } from "@mui/material";

const BNPSFormat = ({ selected, handleSelect, circlesOnly = false }) => {
  return (
    <Box>
      {/* Number Buttons */}
      <Grid container mb={0} mt={circlesOnly ? 5 : 3}>
        {Array.from({ length: 11 }, (_, i) => (
          <Grid
            item
            xs={1}
            sm={1}
            md={1}
            key={i}
            // sx={{ border: "1px solid #000" }}
          >
            <IconButton
              variant={selected === i ? "contained" : "outlined"}
              onClick={() => handleSelect(i)}
              sx={{
                width: { xs: "22px", sm: "24px", md: "48px" },
                height: { xs: "22px", sm: "24px", md: "48px" },
                minWidth: "0px",
                minHeight: "0px",
                // fontSize: { xs: "0.8rem", sm: "1rem", md: "1.5rem" },
                borderRadius: "50%",
                border: { xs: "1px solid #ffa000", md: "2px solid #ffa000" },
                color: "#000",
                backgroundColor: selected === i ? "#ffa000" : "#fff",
                // m: { xs: 0.2, md: 0.5 },
                "&:hover": {
                  backgroundColor: "#ffd54f",
                },
              }}
            >
              <Typography
                sx={{
                  color: selected === i ? "#fff" : "#ffa000",
                  fontWeight: "bold",
                  fontSize: {
                    xs: "0.875rem",
                    sm: "1rem",
                    md: "1rem",
                    lg: "1.125rem",
                  },
                }}
              >
                {i}
              </Typography>
            </IconButton>
          </Grid>
        ))}
      </Grid>

      {!circlesOnly && (
      <>
      {/* Bracket Line Above Labels */}
      <Grid container justifyContent="center" position="relative" mt={2} mb={1}>
        {/* Bracket 0-6 */}
        <Box
          sx={{
            position: "absolute",
            left: { xs: "4%", sm: "2%", md: "0.5%" },
            width: { xs: "50%", sm: "50%", md: "53%" },
            borderBottom: "1px solid #000",
            borderLeft: "1px solid #000",
            borderRight: "1px solid #000",
            height: 12,
            top: 0,
          }}
        />
        {/* Bracket 7-8 */}
        <Box
          sx={{
            position: "absolute",
            left: { xs: "62%", sm: "60%", md: "59%" },
            width: { xs: "10%", sm: "10%", md: "10.5%" },
            borderBottom: "1px solid #000",
            borderLeft: "1px solid #000",
            borderRight: "1px solid #000",
            height: 12,
            top: 0,
          }}
        />
        {/* Bracket 9-10 */}
        <Box
          sx={{
            position: "absolute",
            right: { xs: "11.5%", sm: "13.5%", md: "13.5%" },
            width: { xs: "10%", sm: "10.5%", md: "10.5%" },
            borderBottom: "1px solid #000",
            borderLeft: "1px solid #000",
            borderRight: "1px solid #000",
            height: 12,
            top: 0,
          }}
        />
      </Grid>

      <Grid item container justifyContent="space-arround" mb={2}>
        {/* 0-6: Highly Unlikely (7 numbers, so xs=7) */}
        <Grid
          item
          xs={7}
          sm={5}
          md={6.4}
          style={{
            textAlign: "center",
            marginTop: 6,
            // marginLeft: 18
          }}
        >
          <Typography
            variant="body2"
            sx={{
              fontSize: {
                xs: "0.75rem",
                sm: "0.875rem",
                md: "1rem",
                lg: "1rem",
              },
            }}
          >
            Highly Unlikely
          </Typography>
        </Grid>
        {/* 7-8: Somewhat Likely (2 numbers, so xs=2) */}
        <Grid
          item
          xs={2}
          sm={1}
          md={2.3}
          style={{
            textAlign: "center",
            // marginLeft: 28,
            marginTop: 6,
          }}
        >
          <Typography
            variant="body2"
            sx={{
              fontSize: {
                xs: "0.75rem",
                sm: "0.875rem",
                md: "1rem",
                lg: "1rem",
              },
            }}
          >
            Somewhat Likely
          </Typography>
        </Grid>
        {/* 9-10: Very Likely (2 numbers, so xs=2) */}
        <Grid
          item
          xs={2}
          sm={1}
          md={2.3}
          style={{
            textAlign: "center",
            // marginRight: 12,
            marginTop: 6,
          }}
        >
          <Typography
            variant="body2"
            sx={{
              fontSize: {
                xs: "0.75rem",
                sm: "0.875rem",
                md: "1rem",
                lg: "1rem",
              },
            }}
          >
            Very Likely
          </Typography>
        </Grid>
      </Grid>
      </>
      )}
    </Box>
  );
};

export default BNPSFormat;
